import {AlertCircle, BrainCircuit, TrendingDown, Frown} from 'lucide-react'

function Problems() {
  const problems = [
    {
      icon: AlertCircle,
      title: "Проваленные дедлайны",
      description: "Клиенты злятся, деньги утекают.",
    },
    {
      icon: BrainCircuit,
      title: "Синдром самозванца",
      description: "Ты ничего не сделал за день, но дико устал.",
    },
    {
      icon: TrendingDown,
      title: "Финансовые качели",
      description: "То густо, то пусто. Нет понимания дохода.",
    },
    {
      icon: Frown,
      title: "Вина за простой",
      description: "Ты не отдыхаешь, потому что должен работать.",
    },
  ]

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8 bg-gray-50 fade-on-scroll opacity-0">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-center text-black mb-12 sm:mb-16 uppercase">
          ТЫ ЗНАКОМ С ЭТИМ?
        </h2>

        <div className="grid sm:grid-cols-2 gap-6 sm:gap-8 mb-12">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="bg-white p-6 sm:p-8 rounded-lg shadow-lg border-l-4 border-[#D32F2F] hover:shadow-xl transition-shadow duration-200"
            >
              <problem.icon className="w-12 h-12 sm:w-14 sm:h-14 text-[#D32F2F] mb-4" strokeWidth={2.5} />
              <h3 className="text-xl sm:text-2xl font-bold text-black mb-2">
                {problem.title}
              </h3>
              <p className="text-base sm:text-lg text-gray-600">
                {problem.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-xl sm:text-2xl font-bold text-[#D32F2F] max-w-3xl mx-auto">
            Это не лень. Это отсутствие системы. Хаос разрушает твой доход.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Problems
